const e = "label_Nz8sp", _ = "label__text_UkYMC", l = "label__text__noPadded_N3eTr", t = {
  label: e,
  label__text: _,
  label__text__noPadded: l
};
export {
  t as default,
  e as label,
  _ as label__text,
  l as label__text__noPadded
};
//# sourceMappingURL=label.module.scss.js.map
